/**
 * Sector Operations — Plant Quality Client Service (SO-P266, J4.a, J4.b).
 */

import { callable } from './callable'
import type {
  SetPlantNearMissExportPeopleInput,
  SetPlantNearMissExportPeopleResult,
} from '../types/ops'

export async function setPlantNearMissExportPeople(
  input: SetPlantNearMissExportPeopleInput,
): Promise<SetPlantNearMissExportPeopleResult> {
  return callable<SetPlantNearMissExportPeopleInput, SetPlantNearMissExportPeopleResult>(
    'setPlantNearMissExportPeople',
    input,
  )
}
